import { Link } from 'react-router-dom';
import { MapPin, Envelope, Phone, LinkedinLogo, YoutubeLogo, InstagramLogo } from '@phosphor-icons/react';
import { useLanguage } from '../context/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-xgrids-bg-secondary border-t border-white/10" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img 
                src="https://xgrids.com/assets/logo_white.ceffc551.png" 
                alt="XGRIDS" 
                className="h-8"
              />
              <span className="font-heading font-bold text-lg text-xgrids-brand-primary">.ID</span>
            </Link>
            <p className="text-xgrids-text-secondary text-sm leading-relaxed mb-6">
              {t('footer.desc')}
            </p>
            <div className="flex gap-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xgrids-text-muted hover:text-xgrids-brand-primary transition-colors"
                data-testid="social-linkedin"
              >
                <LinkedinLogo size={24} weight="fill" />
              </a>
              <a 
                href="https://youtube.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xgrids-text-muted hover:text-xgrids-brand-primary transition-colors"
                data-testid="social-youtube"
              >
                <YoutubeLogo size={24} weight="fill" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xgrids-text-muted hover:text-xgrids-brand-primary transition-colors"
                data-testid="social-instagram"
              >
                <InstagramLogo size={24} weight="fill" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6">{t('footer.products')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/produk" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                  PortalCam
                </Link>
              </li>
              <li>
                <Link to="/produk" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                  Lixel L2 Pro
                </Link>
              </li>
              <li>
                <a href="https://xgrids.com/products" target="_blank" rel="noopener noreferrer" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                  {t('footer.allProducts')}
                </a>
              </li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6">{t('footer.industries')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/industri" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                  {t('industry.surveyGeo')}
                </Link>
              </li>
              <li>
                <Link to="/industri" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                  {t('industry.aec')}
                </Link>
              </li>
              <li>
                <Link to="/industri" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                  {t('industry.film')}
                </Link>
              </li>
              <li>
                <Link to="/industri" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                  {t('industry.energy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-white mb-6">{t('footer.contact')}</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-xgrids-brand-primary flex-shrink-0 mt-0.5" />
                <span className="text-xgrids-text-secondary text-sm">
                  Perkantoran Multiguna Bintaro<br />
                  Sektor 3A No 8M<br />
                  Tangerang Selatan
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Envelope size={20} className="text-xgrids-brand-primary flex-shrink-0" />
                <a href="mailto:info@xgrids.id" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                  info@xgrids.id
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-xgrids-brand-primary flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="tel:+6285921774979" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                    +62 859-2177-4979
                  </a>
                  <a href="tel:+628122033957" className="text-xgrids-text-secondary hover:text-xgrids-brand-primary text-sm transition-colors">
                    +62 812-2033-957
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xgrids-text-muted text-sm">
            © {new Date().getFullYear()} XGRIDS Indonesia. {t('footer.rights')}
          </p>
          <div className="flex gap-6">
            <a href="https://xgrids.com" target="_blank" rel="noopener noreferrer" className="text-xgrids-text-muted hover:text-xgrids-text-secondary text-sm transition-colors">
              {t('footer.global')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
